import {
  CLOVER_AMEX,
  CLOVER_DISCOVER,
  CLOVER_MASTERCARD,
  CLOVER_VISA
} from 'reservations/payments/constants/cards';

export const getReadableCardType = (cardType: string = ''): string => {
  switch (cardType) {
    case CLOVER_AMEX:
      return 'AMEX';
    case CLOVER_DISCOVER:
      return 'DISC';
    case CLOVER_MASTERCARD:
      return 'MC';
    case CLOVER_VISA:
      return 'VISA';
    default:
      return cardType.toUpperCase();
  }
};
